import ResetPasswordFormModule from "./reset-password-form/module";

const modul = angular.module("AccountResetPasswordComponents", [
    ResetPasswordFormModule,
]);

export default modul.name;
